module.exports = "<app-nav></app-nav>"